import React from "react";
import ContactSection from "../components/ContactSection";

const Contact = () => {
  return (
    <div>
      <ContactSection isFullPage={true} />
    </div>
  );
};

export default Contact;
